import { render } from "./EmployeeUploadSignature.vue?vue&type=template&id=fda7cc4c"
import script from "./EmployeeUploadSignature.vue?vue&type=script&lang=js"
export * from "./EmployeeUploadSignature.vue?vue&type=script&lang=js"

import "./EmployeeUploadSignature.vue?vue&type=style&index=0&id=fda7cc4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__